<div class="card mb-0">
    <div class="card-header">
        <div class="row m-0 p-0">
            <h4 class="col-md-11">{{Circuito?.Titulo}} ({{Circuito?.Fornecedor + "/" + Circuito?.CodigoCircuito}})</h4>
            <div class="col-md-1">
              <button type="button" class="close" style="align-self:flex-start" [disabled]="carregando" aria-label="Close"
                (click)="fecharModal()">
                <span>&times;</span></button>
            </div>
        </div>
        <div class="mb-2 mt-2 p-1">
            <div class="row mt-5 p-2">
              <span class="col-md text-center"><strong style="font-size: 17px">{{"Duração"| translate}}:
                </strong>{{Circuito.Duracao}}</span>
              <span class="col-md text-center"><strong style="font-size: 17px">{{"Categoria"| translate}}:
                </strong>{{Circuito.CategoriaNome}}</span>
              <span class="col-md text-center"><strong style="font-size: 17px">{{"Inicio Em"| translate}}:
                </strong>{{Circuito.CidadeInicio}}</span>
              <span class="col-md text-center" *ngIf="Circuito?.Fornecedor != 'ST'"><strong style="font-size: 17px">{{"Final Em"| translate}}:
                </strong>{{Circuito.CidadeFim}}</span>
              <span class="col-md text-center"><strong style="font-size: 17px">{{"Check-In"| translate}}:
                </strong>{{Circuito.CheckIn | date: 'dd/MM/yyyy'}}</span>
              <span class="col-md text-center"><strong style="font-size: 17px">{{"Check-Out"| translate}}:
                </strong>{{Circuito.CheckOut | date: 'dd/MM/yyyy'}}</span>
              <span class="col-md text-center text-danger"><strong
                  style="font-size: 17px">{{"Prazo Cancelamento"| translate}}:
                </strong>{{politicaCircuitoRS?.Circuito?.PrazoCancelamentoWs | date: 'dd/MM/yyyy'}}</span>
            </div>
        </div>
    </div>

    <div class="card-body">
        <div *ngIf="carregando" class="overlay">
            <app-view-loading></app-view-loading>
        </div>

        <ng-container *ngIf="!reservado">
            <div class="row mb-3 mt-2">

                <div class="col-md text-center"
                  *ngIf="politicaCircuitoRS.Abandonos?.length > 0 || politicaCircuitoRS.Incorporacoes?.length > 0">
                  <label>{{"Deixar o Circuito Flexível ?" | translate}}</label>
                  <div class="btn-group d-flex justify-content-center mt-2" ngbRadioGroup>
                    <label ngbButtonLabel class="me-2 me-md-2">
                      <input ngbButton type="radio" [value]="false" name="botaoFlexivel" [(ngModel)]="Flexivel" (change)="atualizarFlexivel($event)" /> {{"Completo" | translate}}
                    </label>
                    <label ngbButtonLabel class="mx-2 mx-md-2">
                      <input ngbButton type="radio" [value]="true" name="botaoFlexivel" [(ngModel)]="Flexivel" (change)="atualizarFlexivel($event)" /> {{"Flexível" | translate}}
                    </label>
                  </div>
                </div>
              
                <div class="col-md text-center" *ngIf="politicaCircuitoRS.NoitesAdicionais?.length > 0">
                  <label>{{"Deseja Adicionar Noites ao Circuito ?" | translate}}</label>
                  <div class="btn-group d-flex justify-content-center mt-2" ngbRadioGroup>
                    <label ngbButtonLabel class="me-2 me-md-2">
                      <input ngbButton type="radio" [value]="false" name="botaoNoites" [(ngModel)]="NoitesAdicionais" (change)="atualizarNoitesAdicionais($event)" /> {{"Não" | translate}}
                    </label>
                    <label ngbButtonLabel class="mx-2 mx-md-2">
                      <input ngbButton type="radio" [value]="true" name="botaoNoites" [(ngModel)]="NoitesAdicionais" (change)="atualizarNoitesAdicionais($event)" /> {{"Sim" | translate}}
                    </label>
                  </div>
                </div>
              
                <div class="col-md text-center" *ngIf="(TrasladoInicio.Existe || TrasladoFim.Existe)">
                  <label>{{"Deseja Preencher os Traslados ?" | translate}}</label>
                  <div class="btn-group d-flex justify-content-center mt-2" ngbRadioGroup>
                    <label ngbButtonLabel class="me-2 me-md-2">
                      <input ngbButton type="radio" [value]="false" name="botaoTranslado" [(ngModel)]="IncluiTraslados" (change)="ref.detectChanges()" /> {{"Não" | translate}}
                    </label>
                    <label ngbButtonLabel class="mx-2 mx-md-2">
                      <input ngbButton type="radio" [value]="true" name="botaoTranslado" [(ngModel)]="IncluiTraslados" (change)="ref.detectChanges()" /> {{"Sim" | translate}}
                    </label>
                  </div>
                </div>
              
              </div>
              
            <!-- CIRCUITO FLEXIVEL -->
            <div class="accordion m-5" *ngIf="Flexivel" id="accordionFlexivel">
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFlexivel">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseFlexivel" aria-expanded="false" aria-controls="collapseFlexivel">
                        {{ 'Circuito Flexível (Inicio/Fim)' | translate }}
                    </button>
                    </h2>
                    <div id="collapseFlexivel" class="accordion-collapse collapse show" aria-labelledby="headingFlexivel"
                        data-bs-parent="#accordionFlexivel">
                        <div class="accordion-body">
              
                            <div class="row justify-content-center">
                                <div class="col-md-3">
                                    <label>{{"Inicio do Circuito" | translate}}</label>
                                    <select class="form-control" [(ngModel)]="DataIncorporacao" (ngModelChange)="setFlexIn($event)"
                                        name="select-incorporacao" id="select-incorporacao-id">
                                        <option *ngFor="let incorporacao of politicaCircuitoRS?.Incorporacoes; let i = index;"
                                            [ngValue]="incorporacao.Data" [id]="i + 'id-incorporacao'">
                                            {{ (incorporacao.Data | date: 'dd/MM/yyyy') + " - " + incorporacao.CodigoSemana + " - " + incorporacao.CidadeNome }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <label>{{"Fim do Circuito" | translate}}</label>
                                    <select class="form-control" [(ngModel)]="DataAbandono" (ngModelChange)="setFlexOut($event)"
                                        name="select-abandono" id="select-abandono-id">
                                        <option *ngFor="let abandono of politicaCircuitoRS?.Abandonos; let i = index;"
                                            [ngValue]="abandono.Data" [id]="i + 'id-abandono'">
                                            {{ (abandono.Data | date: 'dd/MM/yyyy') + " - " + abandono.CodigoSemana + " - " + abandono.CidadeNome }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-2 pt-4">
                                    <button class="btn btn-success" [disabled]="!liberaConfirmar"
                                        (click)="confirmarFlexivel()">
                                        {{"Confirmar" | translate}}
                                    </button>
                                </div>
                            </div>
              
                        </div>
                    </div>
                </div>
            </div>
              
            <!-- NOITES ADICIONAIS -->
            <div class="accordion m-5" *ngIf="NoitesAdicionais && politicaCircuitoRS.NoitesAdicionais?.length > 0" id="accordionNoites">
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingNoites">
                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseNoites" aria-expanded="true" aria-controls="collapseNoites">
                            {{ "Noites Adicionais" | translate }}
                        </button>
                    </h2>
                    <div id="collapseNoites" class="accordion-collapse collapse show" aria-labelledby="headingNoites"
                        data-bs-parent="#accordionNoites">
                        <div class="accordion-body">
              
                            <div class="col-md-12 row mb-3 mt-2 justify-content-center"
                                *ngFor="let noiteAdicional of politicaCircuitoRS.NoitesAdicionais; let i = index; let isFirst = first">
                                <div class="col-md text-center align-self-center">
                                    <strong>{{noiteAdicional.TipoNoite == "CO" ? "Começo" : "Final"}}</strong>
                                </div>
                                <div class="col-md text-center align-self-center">
                                    <strong>{{noiteAdicional.CidadeNome}}</strong>
                                </div>
                                <div class="col-md text-center align-self-center">
                                    <strong>{{"De" | translate}}: {{noiteAdicional.DataInicio | date: 'dd/MM/yyyy'}}</strong>
                                </div>
                                <div class="col-md text-center align-self-center">
                                    <strong>{{"Ate" | translate}}: {{noiteAdicional.DataFim | date: 'dd/MM/yyyy'}}</strong>
                                </div>
                                <div class="col-md text-center align-self-center">
                                    <strong>{{noiteAdicional.PaisNome}}</strong>
                                </div>
                                
                                <div class="col-md text-left" *ngIf="noiteAdicional.TipoNoite == 'CO' else ngnoiteFim">
                                    <select class="form-control" style="max-width: 140px" [(ngModel)]="noiteInicio"
                                      (ngModelChange)="confirmarNoitesAdicionais($event, noiteAdicional)">
                                      <option *ngFor="let data of [].constructor(noiteAdicional.QuantidadeNoites); let dt = index"
                                        [selected]="isFirst" [ngValue]="dt">
                                        {{dt + " " + "Noites"}}</option>
                                    </select>
                                </div>
                                <ng-template #ngnoiteFim>
                                    <div class="col-md text-left">
                                        <select class="form-control" style="max-width: 140px" [(ngModel)]="noiteFim"
                                            (ngModelChange)="confirmarNoitesAdicionais($event, noiteAdicional)">
                                            <option *ngFor="let data of [].constructor(noiteAdicional.QuantidadeNoites); let dt = index"
                                                [selected]="isFirst" [ngValue]="dt">
                                                {{ dt + " " + "Noites" }}
                                            </option>
                                        </select>
                                    </div>
                                </ng-template>
                            </div>
              
                        </div>
                    </div>
                </div>
            </div>
              
            <div class="accordion m-5 h-100" *ngIf="IncluiTraslados && (TrasladoInicio.Existe || TrasladoFim.Existe)" id="accordionTraslado">
                <div class="accordion-item h-100">
                    <h2 class="accordion-header" id="headingTraslado">
                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseTraslado" aria-expanded="true" aria-controls="collapseTraslado">
                            {{ "Preencher dados para Translado" | translate }}
                        </button>
                    </h2>
                    <div id="collapseTraslado" class="accordion-collapse collapse show" aria-labelledby="headingTraslado"
                        data-bs-parent="#accordionTraslado">
                        <div class="accordion-body">
              
                            <div class="col-md-12 row mb-3 mt-2 justify-content-center"
                                *ngIf="TrasladoInicio.Existe" [class.paddingBuscando]="buscandoCompanhias">
                                <div class="col-md text-center align-self-center">
                                    <strong>{{"Começo" | translate}}</strong>
                                </div>
                                <div class="col-md text-center align-self-center">
                                    <strong>{{TrasladoInicio.CidadeNome}}({{TrasladoInicio.PaisNome}})</strong>
                                </div>
                                <div class="col-md text-center align-self-center" *ngIf="TrasladoInicio?.DataInicio">
                                    <strong>{{TrasladoInicio.DataInicio | date: 'dd/MM/yyyy'}}</strong>
                                </div>
                                <div class="col-md text-center align-self-center" *ngIf="TrasladoInicio?.DataFim">
                                    <strong>{{TrasladoInicio.DataFim | date: 'dd/MM/yyyy'}}</strong>
                                </div>
                                <div class="col-md">
                                    <typeahead [tap]="true" name="companhiaAutocomplete" [lista]="data"
                                        [searchText]="TrasladoInicioCompanhia" (searchFunction)="onChangeCompanhia($event)"
                                        (selectItem)="selecionaCompanhia($event, true)">
                                        <input class="form-control" [(ngModel)]="TrasladoInicioCompanhia"
                                            (ngModelChange)="onChangeCompanhia($event)" placeholder="Companhia Aérea" />
                                    </typeahead>
                                </div>
                                <div class="col-md">
                                    <input autocomplete="off" class="form-control" [(ngModel)]="TrasladoInicioVoo"
                                        placeholder="Vôo Chegada" maxlength="10" />
                                </div>
                                <div class="col-md-2 d-flex justify-content-center">
                                <button class="btn btn-success"
                                    [disabled]="!liberaConfirmarTrasladoInicio || TrasladoInicioVoo?.length == 0"
                                    (click)="confirmarTrasladoIN()">{{"Confirmar" | translate}}</button>
                                </div>
                                <div class="col-md align-self-center" *ngIf="TrasladoInicio.Confirmado == true">
                                    <i class="fa fa-check" style="color: lime" aria-hidden="true"></i>
                                </div>
                            </div>
              
                            <div class="col-md-12 row mb-3 mt-2 justify-content-center" *ngIf="TrasladoFim.Existe">
                                <div class="col-md text-center align-self-center">
                                    <strong>{{"Final" | translate}}</strong>
                                </div>
                                <div class="col-md text-center align-self-center">
                                    <strong>{{TrasladoFim.CidadeNome}}({{TrasladoFim.PaisNome}})</strong>
                                </div>
                                <div class="col-md text-center align-self-center" *ngIf="TrasladoFim?.DataInicio">
                                    <strong>{{TrasladoFim.DataInicio | date: 'dd/MM/yyyy'}}</strong>
                                </div>
                                <div class="col-md text-center align-self-center" *ngIf="TrasladoFim?.DataFim">
                                    <strong>{{TrasladoFim.DataFim | date: 'dd/MM/yyyy'}}</strong>
                                </div>
                                <div class="col-md">
                                    <typeahead [tap]="false" name="companhiaAutocomplete" [lista]="data"
                                        [searchText]="TrasladoFimCompanhia" (searchFunction)="onChangeCompanhia($event, false)"
                                        (selectItem)="selecionaCompanhia($event, false)">
                                        <input autocomplete="false" class="form-control" [(ngModel)]="TrasladoFimCompanhia"
                                            (ngModelChange)="onChangeCompanhia($event, false)" placeholder="Companhia Aérea" />
                                    </typeahead>
                                </div>
                                <div class="col-md">
                                    <input autocomplete="off" class="form-control" [(ngModel)]="TrasladoFimVoo"
                                    placeholder="Vôo Partida" maxlength="10" />
                                </div>
                                <div class="col-md-2 d-flex justify-content-center">
                                    <button class="btn btn-success"
                                        [disabled]="!liberaConfirmarTrasladoFim || TrasladoFimVoo?.length == 0"
                                        (click)="confirmarTrasladoOUT()">{{"Confirmar" | translate}}</button>
                                </div>
                                <div class="col-md align-self-center" *ngIf="TrasladoFim.Confirmado == true">
                                    <i class="fa fa-check" style="color: lime" aria-hidden="true"></i>
                                </div>
                            </div>
              
                        </div>
                    </div>
                </div>
            </div>                          

            <div class="row m-5">
                <div class="col-sm-12 d-flex justify-content-end">
                    <div class="col-md-9">
                        <div class="card shadow-sm border-0" *ngIf="buscouValor">
                            <div class="card-body p-0">
                                <div class="table-responsive">
                                    <table class="table m-0">
                                        <thead class="bg-light">
                                            <tr>
                                                <th class="text-start">{{ "Produto" | translate }}</th>
                                                <th class="text-start">{{ "Valor" | translate }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of ValorProdutos">
                                                <td class="text-start text-muted">Itinerario: {{ item.NomeProduto }}</td>
                                                <td class="text-start text-muted">
                                                    {{ item.Moeda?.Sigla }} {{ item.ValorProduto.toFixed(2) }}
                                                </td>
                                            </tr>
                                            <tr class="bg-light">
                                                <td class="text-start fw-bold" style="font-size: 16px;">
                                                    {{ "Total" | translate }}:
                                                </td>
                                                <td class="text-start fw-bold">
                                                    {{ politicaCircuitoRS?.Moeda?.Sigla }} {{ politicaCircuitoRS?.ValorTotal.toFixed(2) }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3 d-flex align-items-center justify-content-center flex-column text-center">
                        <button class="btn btn-success" (click)="exibirValor()" [disabled]="carregando"
                          style="max-width: 200px !important;">
                          <i class="fas fa-money-bill-alt me-2"></i>{{buscouValor ? 'Atualizar Valor' : 'Exibir Valor' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </ng-container>

        <div class="col-md-12 m-5 text-center" *ngIf="reservado">
            <h4>{{"Circuito Reservado com Sucesso!" | translate }}</h4>
        </div>

        <div class="accordion" id="accordionPoliticaCancelamento" *ngIf="politicaCircuitoRS?.PoliticaCancelamento?.length > 0">
            <div class="accordion-item">
                <h2 class="accordion-header" id="headingCancelamento">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseCancelamento" aria-expanded="false" aria-controls="collapseCancelamento">
                        <h5 class="text-muted mb-0">{{ 'Politica de Cancelamento' | translate }}</h5>
                    </button>
                </h2>
                <div id="collapseCancelamento" class="accordion-collapse collapse" aria-labelledby="headingCancelamento"
                    data-bs-parent="#accordionPoliticaCancelamento">
                    <div class="accordion-body">
                        <div class="row">
                            <p class="col-md-12" *ngFor="let politica of politicaCircuitoRS?.PoliticaCancelamento">
                                {{ politica }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
          

        <div *ngIf="circuitoRetarifado" class="col-md-12 row justify-content-center mt-3 mb-3">
            <h5 style="color: red;" class="col-md-12 text-center">{{"ATENÇÃO o valor do circuito alterou" | translate}}!</h5>
            <strong class="col-md-12 text-center"
              style="font-size: 17px !important">{{"Valor Atualizado" | translate}}:{{politicaCircuitoRS?.Circuito?.MoedaListagem?.Sigla}}{{politicaCircuitoRS?.Circuito?.ValorListagem?.toFixed(2)}}</strong>
            <nb-alert status="danger" class="col-md-12 text-center" closable (close)="limparMensagemTarifacao()">
              {{'O Valor do circuito foi atualizado' | translate}}</nb-alert>
        </div>
    </div>

    <div class="card-footer">
        <div class="d-flex justify-content-center flex-row gap-3">
            <button [disabled]="!permiteReservar || carregando || reservado" (click)="reservar()" class="btn btn-primary mx-4"
                type="submit">{{'Reservar Circuito' | translate}}</button>
    
            <button [disabled]="carregando" (click)="salvar()" class="btn btn-success mx-4"
                type="submit">{{'Salvar' | translate}}</button>
    
            <button (click)="fecharModal()" [disabled]="carregando" class="btn btn-danger mx-4"
                type="submit">{{'Fechar' | translate}}</button> 
        </div>
        <div *ngIf="mensagensSucesso.length > 0 || mensagensErro.length > 0" class="col-md-12 row">
            <div class="col-md-12 mt-3" *ngIf="mensagensSucesso.length > 0">
                <div class="success" closable (close)="limparMensagens()">
                    <ul>
                        <li *ngFor="let m of mensagensSucesso">
                          {{m | translate}}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-md-12 mt-3" *ngIf="mensagensErro.length > 0">
                <div class="danger" closable (close)="limparMensagens()">
                    <ul>
                        <li *ngFor="let m of mensagensErro">
                          {{m | translate}}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
